// extracted by mini-css-extract-plugin
export var lightMode = "_n-0";